import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Routing from './Routing';
import { buamatogTheme } from './theme';

import { SnackbarProvider } from 'notistack';
import { setAuthToken } from './Hooks/setAuthToken';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (localStorage.getItem('buamatog-access-token')) {
    setAuthToken(localStorage.getItem('buamatog-access-token'));
}

root.render(
  <React.StrictMode>
    <ThemeProvider theme={buamatogTheme}>
      <CssBaseline />
      <SnackbarProvider hideIconVariant maxSnack={5}>
        <Routing />
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
